import { createContext } from 'react';
import EditStockModuleContext from 'types/contexts/EditStockModuleContext';

export default createContext({} as EditStockModuleContext);
